var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3058_89593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.264 422.602H853.393V544.779L780.204 496.404L673.861 541.677L566.264 496.403L473.058 582.61L372.342 611.14L327.928 574.548L292.897 521.831L259.742 553.462L185.926 492.062L134.63 499.505L77.08 450.509L2.63965 431.904L3.264 422.602Z",
    fill: "#384252",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 422.602V423.203H852.787V543.655L780.267 495.722L673.859 541.023L566.139 495.697L472.75 582.071L372.483 610.474L328.385 574.142L293.001 520.896L259.714 552.653L186.108 491.428L134.816 498.869L77.3663 449.961L3.27796 431.443L3.86903 422.642L3.26384 422.602V423.203V422.602L2.65865 422.562L2 432.364L76.7934 451.058L134.445 500.14L185.745 492.697L259.769 554.27L292.792 522.767L327.47 574.953L372.201 611.805L473.364 583.148L566.39 497.109L673.861 542.331L780.141 497.085L854 545.903V422H2.69597L2.65865 422.562L3.26384 422.602Z",
    fill: "#384252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 422.602V423.203H852.787V543.655L780.267 495.722L673.859 541.023L566.139 495.697L472.75 582.071L372.483 610.474L328.385 574.142L293.001 520.896L259.714 552.653L186.108 491.428L134.816 498.869L77.3663 449.961L3.27796 431.443L3.86903 422.642L3.26384 422.602ZM3.26384 422.602V423.203V422.602ZM3.26384 422.602L2.65865 422.562L2 432.364L76.7934 451.058L134.445 500.14L185.745 492.697L259.769 554.27L292.792 522.767L327.47 574.953L372.201 611.805L473.364 583.148L566.39 497.109L673.861 542.331L780.141 497.085L854 545.903V422H2.69597L2.65865 422.562L3.26384 422.602Z",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.04 361.416L223.29 362.656L306.91 413.096L307.66 411.856L224.04 361.416Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.26 362.716L217.33 372.546L301.94 423.546L307.05 413.136L223.26 362.716Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.04 383.126C185.04 383.126 179.04 372.126 167.04 384.126L176.04 395.886C176.04 395.886 174.82 398.406 177.04 399.126C179.26 399.846 181.67 397.776 180.85 395.946C180.03 394.116 179.04 394.126 179.04 394.126L179.32 384.026L185.04 383.126Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.04 385.126C169.04 385.126 178.04 376.126 183.04 384.126",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.35 366.096V351.766L179.42 354.316V366.776L182.35 366.096Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.69 361.086V330.996H278.32V361.236L263.69 361.086Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.48 389.526L198.56 391.526H196.93L196.09 389.526H179.65V393.626H176.82V341.066H179.82L179.59 383.956H192.04L196.04 380.126V372.126H200.04L199.54 383.956L199.48 387.516V389.526Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.93 354.136C176.93 354.556 179.93 353.976 179.93 353.976C179.93 353.976 182.64 352.226 183.06 350.206C183.13 349.206 183.95 349.916 183.27 347.206C183.38 346.726 181.89 346.206 181.89 346.206C181.563 347.756 180.878 349.208 179.89 350.446C178.738 351.501 177.327 352.233 175.8 352.566C175.8 352.566 175.37 353.786 176.91 354.106L176.93 354.136Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.72 366.236H181.92V368.576H176.92L176.72 366.236Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.34 331.066V356.436H278.25V330.916L268.34 331.066Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.51 359.136H265.33V361.366H268.51V359.136Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.06 355.846H269.05V359.776H277.06V355.846Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.95 352.826H270.43V355.476H275.95V352.826Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.69 372.126L182.02 372.016V377.016H179.69V372.126Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.19 355.276V367.796V355.276Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.19 355.276V367.796",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.47 321.146H224.59L241.54 360.926L209.16 360.846L209.48 321.136L209.47 321.146Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.54 321.306V295.566L238.36 283.406L238.21 321.526L209.54 321.296V321.306Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.54 361.006L317.47 371.676L195.54 372.626V361.006H317.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.09 357.446L209.68 357.316V360.316H196.09V357.446Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.54 359.136H209.36V361.366H212.54V359.136Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.43 357.766H240.54V360.626H224.48L224.43 357.766Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.8 358.876H221.62V361.106H224.8V358.876Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.09 355.846H213.08V359.776H221.09V355.846Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.98 352.826H214.46V355.476H219.98V352.826Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.24 372.126H186.54V376.686H182.14L182.25 372.126H182.24Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.22 355.276V367.796V355.276Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.22 355.276V367.796",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.46 392.816V422.626H598.54V392.626L300.46 392.816Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.46 338.946V389.626H467.54L427.54 338.626L317.46 338.946Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.46 389.626V392.626H598.54V389.626H300.46Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.46 335.626V338.626H427.54V335.626H318.46Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.46 331.626V334.626H426.54V331.626H318.46Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.54 392.816V422.626H615.54V392.626L598.54 392.816Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.54 279.316V388.626H614.54V287.156L608.04 283.156L601.54 279.316Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.04 277.816V298.126L601.54 300.626V279.456L599.79 278.616L598.04 277.816Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.54 288.876L470.54 359.946L478.99 369.826L562.54 298.306L553.54 288.876Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.93 264.626L553.93 288.626L562.38 298.496L598.06 298.196V277.196L581.93 264.626Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.54 389.626V392.626H615.54V389.626H598.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.88 280.726C420.04 272.096 420.04 256.126 390.04 256.126C332.04 256.126 329.04 251.126 317.21 272.126C307.73 288.956 323.54 331.626 323.54 331.626H418.92L419.88 280.726Z",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.45 305.626V274.386H346.92V305.626H361.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.45 360.626V297.626H299.54V360.626H302.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.54 295.626V292.626H298.54V295.626H306.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.54 297.626V282.626H297.54V297.626H300.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.45 286.626V275.626H296.54V284.256C296.54 285.566 298.03 286.616 300.04 286.616V292.126H305.45V286.626Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.37 277.626V273.386H306.37V277.626H310.37Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.54 283.626V279.386H304.37V283.626H317.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.54 280.626V276.386H294.37V280.626H296.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.37 268.626V266.626H306.37V268.626H310.37Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.87 272.626V268.386H307.87V272.626H308.87Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.54 295.626V284.386H361.92V295.626H364.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.54 293.626V286.386H364.54V293.626H374.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.54 297.496V288.756C349.537 288.192 349.312 287.652 348.913 287.253C348.514 286.854 347.974 286.629 347.41 286.626H321.67C321.106 286.629 320.566 286.854 320.167 287.253C319.768 287.652 319.543 288.192 319.54 288.756V297.486C319.54 298.051 319.764 298.593 320.164 298.992C320.563 299.392 321.105 299.616 321.67 299.616H347.41C347.972 299.613 348.511 299.389 348.91 298.993C349.308 298.596 349.535 298.058 349.54 297.496Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.54 255.626V250.626H334.54V255.626H357.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.54 255.626V250.626H374.54V255.626H397.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.54 295.626V284.386H373.92V295.626H376.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.46 197.626L576.96 195.316L560.22 177.216L557.73 179.526L574.46 197.626Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.04 191.126C555.04 191.126 556.04 188.126 560.04 188.126C564.04 188.126 564.95 186.666 565.3 186.446C569.04 184.126 571.04 187.126 569.04 189.126C564.51 193.656 564.04 188.126 559.04 192.126C552.94 197.006 555.04 191.126 555.04 191.126Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.73 204.716C566.73 204.716 569.86 204.256 570.56 200.316C571.26 196.376 572.85 195.736 573.12 195.426C576.06 192.146 573.45 189.656 571.12 191.276C565.88 194.956 571.24 196.376 566.43 200.606C560.54 205.766 566.73 204.716 566.73 204.716Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.88 170.846L591.03 224.706L617.54 228.336L650.04 260.126V268.516L676.04 295.126H682.14C682.14 295.126 713.06 239.026 671.38 192.266C632.04 148.126 569.88 170.846 569.88 170.846Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.65 228.336L566.04 205.266L566.5 197.806L561.5 192.126L552.99 192.266L526.75 216.186L537.65 228.336Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.04 231.266L565.3 204.016L564.38 198.666L560.38 194.026L555.08 192.266L523.18 221.366L532.04 231.266Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.88 231.446L541.88 220.956L535.37 213.496L523.37 223.976L529.88 231.446Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.54 210.626L583.54 205.896L581.37 200.406L569.42 205.126L571.54 210.626Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.54 182.626L572.54 177.896L570.37 172.406L558.42 177.126L560.54 182.626Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.92 225.726V234.246C590.92 238.861 592.039 243.408 594.18 247.496C596.99 252.826 599.75 256.716 605.73 256.716C611.46 256.716 614.19 253.366 616.88 248.366C619.309 243.777 620.567 238.658 620.54 233.466V225.746L590.92 225.726Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.85 434.706H669.69V571.406H720.85V434.706Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.01 571.476L681.01 571.896V633.626L689.5 637.236L690.35 635.746L700.54 636.176L701.6 637.026L708.39 634.026L709.03 632.756L709.64 571.596H720.54V715.006H670.06V571.476H670.01Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.88 571.866H678.54L678.62 634.116L695.24 638.506L712.24 632.726V571.826H720.54V715.136H669.97L669.89 571.866H669.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.92 444.976V715.126H720.54V435.186",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.92 444.976V715.126H720.54V435.186",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.21 454.716V681.536V454.716Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.21 454.716V681.536",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.95 681.136L621.95 686.536L669.95 690.136V681.136Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.95 700.346L621.95 705.746L669.95 709.346V700.346Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.68 700.346L768.68 705.746L720.68 709.346V700.346Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.68 681.136L768.68 686.536L720.68 690.136V681.136Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.1 416.046H667.55V418.746H670.1V416.046Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.31 416.046H686.76V418.746H689.31V416.046Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.02 416.046H701.47V418.746H704.02V416.046Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.68 416.046H721.13V418.746H723.68V416.046Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.83 403.746H721.28V406.446H723.83V403.746Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.17 403.746H701.62V406.446H704.17V403.746Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.31 403.596H686.76V406.296H689.31V403.596Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.25 403.896H667.7V406.596H670.25V403.896Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.54 406.156V390.696H712.16V406.456L678.54 406.156Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.42 406.296L666.53 416.036H724.08V406.296H666.42Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.36 411.216L724.19 411.326L666.36 411.216Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.36 411.216L724.19 411.326",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.74 373.986V370.426H745.04V373.986H740.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.25 372.846H722.91L724.29 375.286H737.03V374.016H748.92L749.4 376.086H762.83L759.06 383.516H749.54L748.21 385.006H737.62L736.62 383.736H723.87V387.136H713.36L713.25 372.866V372.846Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.17 390.796L713.32 390.846V369.086H676.25L676.17 390.796Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.07 368.996H682.52V371.696H685.07V368.996Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.93 360.506H678.38V363.206H680.93V360.506Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.4 360.346H710.85V363.046H713.4V360.346Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.04 368.836H705.49V371.536H708.04V368.836Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.88 362.816V369.346H715.79V362.816H674.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.99 365.946H715.75H674.99Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.99 365.946H715.75",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.24 375.176C723.473 378 723.401 380.968 724.03 383.826L724.24 375.176Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.24 375.176C723.473 378 723.401 380.968 724.03 383.826",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.919 375.236C736.378 378.094 736.378 381.028 736.919 383.886V375.236Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.919 375.236C736.378 378.094 736.378 381.028 736.919 383.886",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.44 376.236C748.935 378.598 748.952 381.042 749.49 383.396L749.44 376.236Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.44 376.236C748.935 378.598 748.952 381.042 749.49 383.396",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.62 362.806V353.256H683.14V351.406H702.94V353.316H699.16V362.816H686.62V362.806Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.189 351.406V246.626V351.406Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.189 351.406V246.626",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.04 348.126L204.21 292.786C204.318 291.717 204.654 290.683 205.196 289.755C205.738 288.827 206.472 288.026 207.35 287.406C209.66 285.406 217.11 282.456 217.11 282.456L313.54 251.526C314.814 251.118 316.173 251.053 317.48 251.336C319.299 251.735 320.93 252.736 322.11 254.176L327 260.126L326.66 261.966C322.283 264.699 318.627 268.444 316 272.886L306 287.126V298.126H314L322 328.126L302 357.126H204L204.04 348.126Z",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.84 422.106L563.08 395.106H300.24V422.106L565.84 422.156V422.106Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.46 395.776V419.496H565.68L562.98 395.626L300.46 395.776Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.54 386.626C178.54 386.626 273.54 393.626 288.54 379.626C297.34 371.406 317.54 332.626 317.54 332.626C318.6 329.436 323.54 330.016 323.54 330.016",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.35 274.216L451.76 266.586L459.12 268.406C459.12 268.406 470.78 210.466 471.32 208.596C471.98 207.546 474.84 203.356 478.66 202.646C482.75 202.996 487.25 206.216 487.25 206.216C487.25 206.216 508.57 231.376 513.06 259.086L506.85 277.726L516.02 281.206C517.58 297.666 516.91 314.206 503.55 345.546L496.39 342.546L489.93 367.916C464.3 397.496 445.78 401.916 445.78 401.916C443.72 402.836 437.78 400.576 437.78 400.576C434.99 398.296 434.15 394.076 434.15 394.076L446.55 333.076L437.91 330.776C446.66 307.776 449.41 274.126 449.41 274.126L449.35 274.216Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.04 335.126L375.04 305.126C375.7 292.856 372.98 288.126 378.04 279.126L388.7 268.496L391.16 268.386L515.69 288.386C515.69 288.386 518.29 304.696 506.21 337.896L432.04 321.126L382.04 342.126L377.04 335.126Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.47 224.396C490.087 225.41 489.412 226.288 488.529 226.918C487.647 227.549 486.598 227.903 485.514 227.936C484.43 227.97 483.361 227.681 482.441 227.107C481.522 226.532 480.793 225.698 480.348 224.71C479.902 223.721 479.76 222.622 479.94 221.553C480.119 220.484 480.611 219.492 481.355 218.702C482.098 217.913 483.059 217.362 484.115 217.119C485.172 216.875 486.277 216.951 487.29 217.336C488.648 217.852 489.745 218.885 490.341 220.208C490.937 221.532 490.984 223.038 490.47 224.396Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.98 223.316C486.853 223.656 486.628 223.95 486.333 224.161C486.039 224.373 485.688 224.492 485.326 224.504C484.963 224.516 484.606 224.42 484.298 224.229C483.99 224.037 483.746 223.758 483.597 223.428C483.448 223.097 483.401 222.73 483.461 222.372C483.521 222.015 483.686 221.683 483.934 221.419C484.183 221.156 484.505 220.972 484.858 220.891C485.212 220.81 485.581 220.837 485.92 220.966C486.369 221.141 486.732 221.485 486.93 221.924C487.128 222.364 487.146 222.864 486.98 223.316Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.85 274.846C501.467 275.86 500.791 276.738 499.909 277.368C499.027 277.998 497.977 278.353 496.894 278.386C495.81 278.42 494.741 278.131 493.821 277.557C492.901 276.982 492.173 276.148 491.728 275.159C491.282 274.171 491.14 273.072 491.32 272.003C491.499 270.934 491.991 269.941 492.734 269.152C493.478 268.363 494.438 267.811 495.495 267.568C496.552 267.325 497.657 267.401 498.67 267.786C500.027 268.302 501.124 269.334 501.721 270.658C502.317 271.982 502.363 273.488 501.85 274.846Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.34 273.756C498.212 274.092 497.987 274.383 497.694 274.592C497.401 274.801 497.053 274.918 496.693 274.929C496.334 274.94 495.979 274.844 495.674 274.653C495.369 274.462 495.127 274.186 494.979 273.858C494.831 273.53 494.784 273.166 494.843 272.811C494.902 272.456 495.065 272.127 495.311 271.864C495.557 271.602 495.876 271.418 496.226 271.337C496.576 271.255 496.943 271.28 497.28 271.406C497.731 271.579 498.095 271.923 498.294 272.363C498.492 272.803 498.509 273.304 498.34 273.756Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.61 268.876C472.225 269.887 471.55 270.761 470.668 271.388C469.786 272.015 468.739 272.366 467.658 272.397C466.576 272.429 465.51 272.139 464.594 271.565C463.677 270.99 462.951 270.157 462.508 269.17C462.065 268.184 461.925 267.088 462.104 266.021C462.284 264.954 462.776 263.965 463.518 263.178C464.26 262.391 465.218 261.841 466.273 261.599C467.327 261.356 468.429 261.432 469.44 261.816C470.112 262.071 470.727 262.456 471.25 262.949C471.773 263.442 472.194 264.033 472.488 264.689C472.783 265.345 472.945 266.052 472.966 266.77C472.987 267.489 472.866 268.204 472.61 268.876Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.12 267.796C468.992 268.132 468.767 268.423 468.474 268.632C468.181 268.84 467.833 268.958 467.474 268.969C467.114 268.979 466.759 268.883 466.454 268.693C466.149 268.502 465.907 268.226 465.76 267.898C465.612 267.57 465.564 267.205 465.623 266.851C465.682 266.496 465.845 266.166 466.091 265.904C466.338 265.642 466.656 265.458 467.006 265.377C467.357 265.295 467.723 265.319 468.06 265.446C468.511 265.619 468.875 265.963 469.074 266.403C469.272 266.843 469.289 267.344 469.12 267.796Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.38 345.756C486.996 346.77 486.321 347.648 485.438 348.278C484.556 348.908 483.507 349.263 482.423 349.296C481.339 349.33 480.27 349.041 479.35 348.467C478.431 347.892 477.702 347.058 477.257 346.069C476.812 345.081 476.67 343.982 476.849 342.913C477.028 341.844 477.52 340.852 478.264 340.062C479.007 339.273 479.968 338.722 481.024 338.478C482.081 338.235 483.186 338.311 484.2 338.696C485.557 339.212 486.654 340.245 487.25 341.568C487.846 342.892 487.893 344.398 487.38 345.756Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.89 344.626C483.763 344.966 483.538 345.26 483.243 345.472C482.949 345.683 482.598 345.802 482.236 345.814C481.874 345.826 481.516 345.73 481.208 345.539C480.9 345.347 480.657 345.068 480.508 344.738C480.359 344.407 480.311 344.04 480.371 343.682C480.431 343.325 480.596 342.993 480.845 342.729C481.093 342.466 481.415 342.282 481.768 342.201C482.122 342.12 482.491 342.147 482.83 342.276C483.281 342.449 483.645 342.793 483.844 343.233C484.042 343.673 484.059 344.174 483.89 344.626Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.54 339.966C458.155 340.977 457.479 341.851 456.598 342.478C455.716 343.105 454.668 343.456 453.587 343.487C452.506 343.519 451.44 343.229 450.523 342.655C449.607 342.08 448.881 341.247 448.438 340.26C447.995 339.274 447.854 338.178 448.034 337.111C448.214 336.044 448.706 335.055 449.448 334.268C450.19 333.481 451.148 332.931 452.202 332.689C453.256 332.447 454.359 332.522 455.37 332.906C456.043 333.16 456.659 333.545 457.182 334.037C457.706 334.53 458.127 335.122 458.422 335.778C458.716 336.434 458.878 337.141 458.899 337.86C458.919 338.579 458.797 339.295 458.54 339.966Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.09 338.886C454.961 339.221 454.735 339.51 454.442 339.718C454.148 339.925 453.8 340.04 453.441 340.05C453.082 340.06 452.728 339.963 452.424 339.772C452.12 339.581 451.879 339.304 451.732 338.976C451.585 338.649 451.538 338.285 451.597 337.931C451.656 337.576 451.819 337.248 452.065 336.986C452.31 336.724 452.628 336.54 452.978 336.458C453.328 336.377 453.694 336.4 454.03 336.526C454.484 336.699 454.85 337.044 455.049 337.487C455.247 337.929 455.262 338.433 455.09 338.886Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.08 388.116C459.695 389.127 459.019 390.001 458.138 390.628C457.256 391.255 456.209 391.606 455.127 391.637C454.046 391.669 452.98 391.379 452.063 390.805C451.147 390.23 450.421 389.397 449.978 388.41C449.535 387.424 449.394 386.328 449.574 385.261C449.754 384.194 450.246 383.205 450.988 382.418C451.73 381.631 452.688 381.081 453.742 380.839C454.797 380.596 455.899 380.672 456.91 381.056C457.583 381.31 458.199 381.695 458.722 382.187C459.246 382.68 459.667 383.271 459.962 383.927C460.256 384.583 460.419 385.291 460.439 386.01C460.459 386.729 460.337 387.444 460.08 388.116Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.54 387.026C456.455 387.25 456.327 387.455 456.163 387.629C455.999 387.804 455.802 387.944 455.584 388.043C455.366 388.141 455.13 388.196 454.891 388.203C454.652 388.211 454.414 388.171 454.19 388.086C453.966 388.001 453.761 387.873 453.586 387.709C453.412 387.545 453.271 387.349 453.173 387.131C453.075 386.912 453.02 386.677 453.013 386.438C453.005 386.198 453.045 385.96 453.13 385.736C453.301 385.284 453.644 384.918 454.085 384.719C454.526 384.521 455.027 384.505 455.48 384.676C455.932 384.847 456.298 385.191 456.496 385.632C456.695 386.072 456.711 386.574 456.54 387.026Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.43 278.076L509.82 274.406C509.82 274.406 510.56 273.516 511.1 273.606L516.17 275.406C516.591 275.843 516.825 276.429 516.82 277.036L515.33 280.796L508.44 278.046L508.43 278.076Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.82 273.626C511.82 273.626 512.33 271.496 512.67 271.386L516.35 272.736C516.53 273.046 515.62 275.036 515.62 275.036L511.83 273.626H511.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.69 262.456C458.69 262.456 459.45 260.406 459.23 260.126L455.43 259.186C455.11 259.336 454.76 261.516 454.76 261.516L458.69 262.456Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.95 268.126L459.95 264.326C459.95 264.326 459.84 263.166 459.36 262.936L454.19 261.466C453.893 261.518 453.611 261.628 453.358 261.792C453.106 261.955 452.888 262.167 452.72 262.416L451.72 266.346L458.93 268.096L458.95 268.126Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.3 337.136C439.3 337.136 438.53 339.186 438.75 339.466L442.56 340.406C442.88 340.246 443.23 338.076 443.23 338.076L439.3 337.136Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.04 331.456L438.04 335.246C438.04 335.246 438.15 336.406 438.63 336.636L443.8 338.096C444.1 338.039 444.386 337.92 444.638 337.748C444.891 337.576 445.106 337.354 445.27 337.096L446.27 333.166L439.06 331.406L439.04 331.456Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.31 348.446C496.31 348.446 495.31 350.396 495.53 350.696L499.23 352.026C499.56 351.886 500.15 349.766 500.15 349.766L496.33 348.436L496.31 348.446Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.54 329.626L463.8 333.826C462.53 341.036 474.96 344.716 476.8 336.376L477.64 332.306L464.54 329.626Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.3 335.626C472.148 336.027 471.88 336.374 471.53 336.623C471.181 336.872 470.765 337.012 470.336 337.025C469.908 337.037 469.484 336.923 469.121 336.695C468.757 336.468 468.469 336.137 468.293 335.746C468.117 335.355 468.06 334.92 468.131 334.497C468.202 334.074 468.397 333.681 468.691 333.369C468.985 333.056 469.365 332.838 469.783 332.741C470.201 332.645 470.639 332.674 471.04 332.826C471.307 332.927 471.551 333.08 471.759 333.275C471.966 333.471 472.133 333.705 472.25 333.965C472.367 334.225 472.432 334.506 472.441 334.791C472.449 335.076 472.401 335.36 472.3 335.626Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.23 279.746L475.17 275.586C476.79 268.446 489.67 269.856 488.1 278.246L487.3 282.336L474.23 279.746Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.67 277.186C483.685 276.757 483.573 276.333 483.347 275.967C483.122 275.602 482.793 275.311 482.402 275.133C482.011 274.955 481.576 274.896 481.153 274.965C480.729 275.034 480.335 275.228 480.021 275.521C479.707 275.814 479.487 276.193 479.388 276.611C479.29 277.029 479.318 277.467 479.469 277.869C479.62 278.272 479.887 278.62 480.236 278.87C480.585 279.121 481 279.262 481.43 279.276C481.714 279.287 481.998 279.241 482.265 279.142C482.532 279.042 482.776 278.891 482.984 278.697C483.192 278.503 483.36 278.269 483.478 278.01C483.595 277.751 483.661 277.471 483.67 277.186Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.73 343.086L495.73 346.866C495.73 346.866 495.84 348.036 496.32 348.266L501.49 349.716C501.787 349.664 502.07 349.554 502.322 349.39C502.575 349.227 502.792 349.015 502.96 348.766L503.96 344.836L496.75 343.086H496.73Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.33 210.596H130.08V265.986H135.33V210.596Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.42 267.626H101.11V271.376H122.42V267.626Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.71 328.626C120.81 335.526 129.52 335.306 131.92 328.776L133.05 324.426",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.71 328.626C120.81 335.526 129.52 335.306 131.92 328.776L133.05 324.426",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.2 421.866H118.63L118.71 327.456L105.2 327.306V421.866Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.81 422.016L115.64 327.456H105.21V421.946L115.82 422.026L115.81 422.016Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.32 324.216H101.23V327.666H122.32V324.216Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.88 270.636H87.2998V324.826H137.88V270.636Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.64 274.086H89.5596V321.366H135.64V274.086Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.93 312.966C99.93 313.623 99.7353 314.265 99.3705 314.81C99.0057 315.356 98.4872 315.782 97.8806 316.033C97.2739 316.285 96.6064 316.35 95.9623 316.222C95.3183 316.094 94.7268 315.778 94.2625 315.314C93.7981 314.849 93.4819 314.258 93.3538 313.614C93.2257 312.97 93.2915 312.302 93.5428 311.695C93.794 311.089 94.2196 310.57 94.7655 310.206C95.3115 309.841 95.9534 309.646 96.61 309.646C97.4906 309.646 98.335 309.996 98.9576 310.618C99.5802 311.241 99.93 312.085 99.93 312.966Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.94 312.966C111.94 313.623 111.745 314.265 111.38 314.81C111.015 315.356 110.497 315.782 109.89 316.033C109.284 316.285 108.616 316.35 107.972 316.222C107.328 316.094 106.737 315.778 106.272 315.314C105.808 314.849 105.492 314.258 105.364 313.614C105.235 312.97 105.301 312.302 105.553 311.695C105.804 311.089 106.229 310.57 106.775 310.206C107.321 309.841 107.963 309.646 108.62 309.646C109.5 309.646 110.345 309.996 110.967 310.618C111.59 311.241 111.94 312.085 111.94 312.966Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.95 312.966C123.95 313.623 123.755 314.265 123.39 314.81C123.025 315.356 122.507 315.782 121.9 316.033C121.293 316.285 120.626 316.35 119.982 316.222C119.338 316.094 118.746 315.778 118.282 315.314C117.818 314.849 117.501 314.258 117.373 313.614C117.245 312.97 117.311 312.302 117.562 311.695C117.814 311.089 118.239 310.57 118.785 310.206C119.331 309.841 119.973 309.646 120.63 309.646C121.51 309.646 122.355 309.996 122.977 310.618C123.6 311.241 123.95 312.085 123.95 312.966Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2596 277.696H133.69C134.008 277.696 134.313 277.822 134.538 278.048C134.763 278.273 134.89 278.578 134.89 278.896V303.516C134.89 303.834 134.763 304.14 134.538 304.365C134.313 304.59 134.008 304.716 133.69 304.716H92.2596C91.9413 304.716 91.6361 304.59 91.411 304.365C91.186 304.14 91.0596 303.834 91.0596 303.516V278.896C91.0596 278.578 91.186 278.273 91.411 278.048C91.6361 277.822 91.9413 277.696 92.2596 277.696Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.24 280.536H93.0098V302.446H133.24V280.536Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.33 265.686H136.83C137.148 265.686 137.453 265.812 137.678 266.038C137.903 266.263 138.03 266.568 138.03 266.886V269.286C138.03 269.604 137.903 269.91 137.678 270.135C137.453 270.36 137.148 270.486 136.83 270.486H129.33C129.012 270.486 128.706 270.36 128.481 270.135C128.256 269.91 128.13 269.604 128.13 269.286V266.886C128.13 266.568 128.256 266.263 128.481 266.038C128.706 265.812 129.012 265.686 129.33 265.686Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.83 203.246H135.33C135.966 203.246 136.577 203.499 137.027 203.949C137.477 204.399 137.73 205.01 137.73 205.646V208.796C137.73 209.433 137.477 210.043 137.027 210.493C136.577 210.943 135.966 211.196 135.33 211.196H130.83C130.193 211.196 129.583 210.943 129.133 210.493C128.683 210.043 128.43 209.433 128.43 208.796V205.626C128.435 204.993 128.69 204.388 129.14 203.942C129.589 203.496 130.197 203.246 130.83 203.246Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.43 206.686H100.81",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.13 192.276V220.496",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.23 194.756V218.176",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.29 197.796V215.286",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.46 201.436V212.956",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.86 203.836V209.506",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.62 205.036V208.496",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.26 323.276C269.26 330.264 266.483 336.967 261.542 341.908C256.6 346.85 249.898 349.626 242.91 349.626C235.921 349.626 229.219 346.85 224.277 341.908C219.336 336.967 216.56 330.264 216.56 323.276C216.56 316.288 219.336 309.585 224.277 304.644C229.219 299.702 235.921 296.926 242.91 296.926C249.898 296.926 256.6 299.702 261.542 304.644C266.483 309.585 269.26 316.288 269.26 323.276Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.2 323.276C266.2 327.882 264.834 332.385 262.275 336.215C259.716 340.045 256.079 343.03 251.823 344.793C247.567 346.556 242.884 347.017 238.366 346.119C233.849 345.22 229.699 343.002 226.442 339.745C223.184 336.487 220.966 332.338 220.068 327.82C219.169 323.302 219.63 318.619 221.393 314.363C223.156 310.108 226.141 306.47 229.971 303.911C233.801 301.352 238.304 299.986 242.91 299.986C245.969 299.985 248.998 300.586 251.824 301.756C254.651 302.926 257.219 304.642 259.382 306.805C261.545 308.968 263.26 311.536 264.43 314.362C265.6 317.188 266.201 320.217 266.2 323.276Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.83 340.736C244.83 341.132 244.713 341.518 244.493 341.847C244.273 342.176 243.961 342.432 243.595 342.584C243.23 342.735 242.828 342.775 242.44 342.698C242.052 342.62 241.696 342.43 241.416 342.15C241.136 341.871 240.946 341.514 240.869 341.126C240.791 340.738 240.831 340.336 240.982 339.971C241.134 339.605 241.39 339.293 241.719 339.073C242.048 338.853 242.435 338.736 242.83 338.736C243.361 338.736 243.869 338.947 244.244 339.322C244.619 339.697 244.83 340.206 244.83 340.736Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.86 323.966C226.86 324.362 226.743 324.748 226.523 325.077C226.304 325.406 225.991 325.662 225.626 325.814C225.26 325.965 224.858 326.005 224.47 325.928C224.082 325.85 223.726 325.66 223.446 325.38C223.166 325.101 222.976 324.744 222.899 324.356C222.822 323.968 222.861 323.566 223.013 323.201C223.164 322.835 223.42 322.523 223.749 322.303C224.078 322.083 224.465 321.966 224.86 321.966C225.391 321.966 225.9 322.177 226.275 322.552C226.65 322.927 226.86 323.436 226.86 323.966Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.35 323.476C262.35 323.872 262.232 324.258 262.013 324.587C261.793 324.916 261.48 325.172 261.115 325.324C260.75 325.475 260.347 325.515 259.959 325.438C259.571 325.36 259.215 325.17 258.935 324.89C258.656 324.611 258.465 324.254 258.388 323.866C258.311 323.478 258.35 323.076 258.502 322.711C258.653 322.345 258.91 322.033 259.238 321.813C259.567 321.593 259.954 321.476 260.35 321.476C260.88 321.476 261.389 321.687 261.764 322.062C262.139 322.437 262.35 322.946 262.35 323.476Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.39 306.706C244.39 307.102 244.272 307.488 244.053 307.817C243.833 308.146 243.52 308.402 243.155 308.554C242.79 308.705 242.387 308.745 241.999 308.668C241.612 308.59 241.255 308.4 240.975 308.12C240.696 307.841 240.505 307.484 240.428 307.096C240.351 306.708 240.391 306.306 240.542 305.941C240.693 305.575 240.95 305.263 241.279 305.043C241.607 304.823 241.994 304.706 242.39 304.706C242.92 304.706 243.429 304.917 243.804 305.292C244.179 305.667 244.39 306.176 244.39 306.706Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.08 416.246H720.54L720.43 435.246L669.99 444.986V416.256L670.08 416.246Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.54 443.386V461.986L712.3 454.706V436.766L678.54 443.386Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.9 459.806V510.906L695.3 501.006L701.3 505.276V457.186L688.94 459.816L688.9 459.806Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.54 461.886V681.816V461.886Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.54 461.886V681.816",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.29 681.696V673.056H680.97V528.896H678.54",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.29 681.696V673.056H680.97V528.896H678.54",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.47 518.166L700.16 522.856V571.786H701.74V584.096H688.87V571.716H690.54V524.776L695.49 518.176L695.47 518.166Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.02 661.056H689.54H681.02Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.02 661.056H689.54",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.32 666.536C701.32 667.723 700.968 668.883 700.309 669.87C699.65 670.856 698.713 671.625 697.616 672.079C696.52 672.534 695.314 672.652 694.15 672.421C692.986 672.189 691.917 671.618 691.078 670.779C690.239 669.94 689.667 668.871 689.436 667.707C689.204 666.543 689.323 665.336 689.777 664.24C690.231 663.144 691 662.207 691.987 661.547C692.974 660.888 694.134 660.536 695.32 660.536C696.912 660.536 698.438 661.168 699.563 662.294C700.688 663.419 701.32 664.945 701.32 666.536Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.2 528.936H709.65V673.066H701.36V681.436",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.2 528.936H709.65V673.066H701.36V681.436",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.46 586.126L682.11 592.626V634.056L689.11 637.056",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.46 586.126L682.11 592.626V634.056L689.11 637.056",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.32 586.126L708.67 592.656V634.086L701.67 637.086",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.32 586.126L708.67 592.656V634.086L701.67 637.086",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.28 616.516L708.71 618.956L701.28 616.516Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.28 616.516L708.71 618.956",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.36 631.896C701.36 633.083 701.008 634.243 700.349 635.229C699.69 636.216 698.753 636.985 697.656 637.439C696.56 637.894 695.354 638.012 694.19 637.781C693.026 637.549 691.957 636.978 691.118 636.139C690.279 635.3 689.707 634.231 689.476 633.067C689.244 631.903 689.363 630.696 689.817 629.6C690.271 628.504 691.04 627.567 692.027 626.907C693.014 626.248 694.174 625.896 695.36 625.896C696.952 625.896 698.478 626.528 699.603 627.653C700.728 628.779 701.36 630.305 701.36 631.896Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.95 661.056H709.47H700.95Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.95 661.056H709.47",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.54 616.516L682.11 618.956L689.54 616.516Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.54 616.516L682.11 618.956",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.44 365.466C748.44 366.943 747.853 368.36 746.808 369.405C745.764 370.449 744.347 371.036 742.87 371.036C741.393 371.036 739.976 370.449 738.931 369.405C737.887 368.36 737.3 366.943 737.3 365.466C737.3 363.989 737.887 362.572 738.931 361.527C739.976 360.483 741.393 359.896 742.87 359.896C744.347 359.896 745.764 360.483 746.808 361.527C747.853 362.572 748.44 363.989 748.44 365.466Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.45 365.976L746.99 365.896L748.45 365.976Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.45 365.976L746.99 365.896",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.44 365.466C748.44 366.943 747.853 368.36 746.808 369.405C745.764 370.449 744.347 371.036 742.87 371.036C741.393 371.036 739.976 370.449 738.931 369.405C737.887 368.36 737.3 366.943 737.3 365.466C737.3 363.989 737.887 362.572 738.931 361.527C739.976 360.483 741.393 359.896 742.87 359.896C744.347 359.896 745.764 360.483 746.808 361.527C747.853 362.572 748.44 363.989 748.44 365.466Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.09 367.996L739.52 367.386L738.09 367.996Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.09 367.996L739.52 367.386",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.4 365.976L738.86 365.896L737.4 365.976Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.4 365.976L738.86 365.896",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.69 363.626L738.99 364.076L737.69 363.626Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.69 363.626L738.99 364.076",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.91 361.626L739.91 362.626L738.91 361.626Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.91 361.626L739.91 362.626",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.83 366.436L739.22 362.176L740.36 361.256L743.77 365.566L742.84 366.436H742.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.66 360.326L741.22 361.596L740.66 360.326Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.66 360.326L741.22 361.596",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.82 365.516C743.834 365.639 743.821 365.763 743.783 365.881C743.745 365.998 743.682 366.106 743.6 366.198C743.517 366.29 743.416 366.363 743.304 366.414C743.191 366.464 743.069 366.49 742.945 366.49C742.822 366.49 742.7 366.464 742.587 366.414C742.474 366.363 742.373 366.29 742.291 366.198C742.208 366.106 742.146 365.998 742.108 365.881C742.07 365.763 742.057 365.639 742.07 365.516C742.057 365.393 742.07 365.269 742.108 365.152C742.146 365.034 742.208 364.926 742.291 364.834C742.373 364.742 742.474 364.669 742.587 364.619C742.7 364.568 742.822 364.542 742.945 364.542C743.069 364.542 743.191 364.568 743.304 364.619C743.416 364.669 743.517 364.742 743.6 364.834C743.682 364.926 743.745 365.034 743.783 365.152C743.821 365.269 743.834 365.393 743.82 365.516Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.92 359.926V361.306V359.926Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.92 359.926V361.306",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.76 367.996L746.33 367.386L747.76 367.996Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.76 367.996L746.33 367.386",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.16 363.626L746.86 364.076L748.16 363.626Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.16 363.626L746.86 364.076",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.94 361.626L745.94 362.626L746.94 361.626Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.94 361.626L745.94 362.626",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.19 360.326L744.63 361.596L745.19 360.326Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.19 360.326L744.63 361.596",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.94 309.326L429.94 321.766L410.94 348.826C393.77 364.766 372.38 339.456 389.66 324.626L418.94 309.326Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.2 345.976C400.987 346.871 398.509 346.85 396.311 345.918C394.113 344.986 392.375 343.219 391.48 341.006C390.585 338.793 390.606 336.315 391.538 334.117C392.47 331.919 394.237 330.181 396.45 329.286C397.546 328.843 398.718 328.62 399.9 328.63C401.082 328.64 402.251 328.882 403.339 329.344C404.428 329.805 405.414 330.477 406.243 331.319C407.072 332.162 407.727 333.16 408.17 334.256C408.613 335.352 408.836 336.524 408.826 337.706C408.816 338.889 408.574 340.057 408.112 341.145C407.651 342.234 406.979 343.22 406.136 344.049C405.294 344.878 404.296 345.533 403.2 345.976Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.31 327.016C398.811 327.217 398.264 327.264 397.738 327.154C397.211 327.043 396.729 326.779 396.353 326.395C395.977 326.01 395.723 325.523 395.624 324.994C395.525 324.466 395.584 323.919 395.795 323.425C396.006 322.93 396.359 322.509 396.81 322.215C397.26 321.921 397.787 321.767 398.325 321.772C398.863 321.778 399.387 321.942 399.831 322.246C400.275 322.549 400.62 322.977 400.82 323.476C400.955 323.808 401.023 324.162 401.02 324.52C401.017 324.878 400.943 325.232 400.803 325.561C400.663 325.89 400.458 326.188 400.202 326.438C399.946 326.688 399.643 326.884 399.31 327.016Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.62 342.626C413.121 342.826 412.573 342.874 412.047 342.764C411.521 342.653 411.039 342.389 410.663 342.004C410.287 341.62 410.033 341.133 409.934 340.604C409.834 340.076 409.894 339.529 410.105 339.035C410.316 338.54 410.669 338.119 411.119 337.825C411.569 337.531 412.097 337.376 412.635 337.382C413.172 337.387 413.696 337.552 414.141 337.856C414.585 338.159 414.929 338.587 415.13 339.086C415.263 339.418 415.33 339.772 415.327 340.13C415.323 340.487 415.249 340.84 415.109 341.169C414.968 341.498 414.765 341.796 414.509 342.046C414.254 342.296 413.952 342.493 413.62 342.626Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.46 348.936C390.961 349.136 390.413 349.184 389.887 349.074C389.361 348.963 388.879 348.699 388.503 348.314C388.127 347.93 387.873 347.443 387.773 346.914C387.674 346.386 387.734 345.839 387.945 345.345C388.156 344.85 388.509 344.429 388.959 344.135C389.409 343.841 389.937 343.687 390.474 343.692C391.012 343.698 391.536 343.862 391.98 344.166C392.425 344.469 392.769 344.897 392.97 345.396C393.103 345.728 393.17 346.082 393.166 346.44C393.163 346.797 393.089 347.15 392.948 347.479C392.808 347.808 392.605 348.106 392.349 348.356C392.094 348.606 391.792 348.803 391.46 348.936Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.71 342.256C401.123 342.503 400.492 342.63 399.855 342.631C399.217 342.632 398.586 342.506 397.998 342.261C397.41 342.016 396.876 341.657 396.428 341.203C395.98 340.75 395.626 340.213 395.388 339.622C395.149 339.031 395.03 338.398 395.038 337.761C395.046 337.124 395.181 336.494 395.434 335.909C395.688 335.325 396.055 334.796 396.514 334.354C396.973 333.913 397.516 333.566 398.11 333.336C398.696 333.099 399.323 332.98 399.954 332.985C400.586 332.99 401.211 333.12 401.793 333.366C402.374 333.613 402.902 333.971 403.345 334.422C403.788 334.872 404.138 335.406 404.375 335.991C404.612 336.577 404.732 337.204 404.727 337.835C404.721 338.467 404.592 339.092 404.345 339.674C404.099 340.255 403.74 340.783 403.29 341.226C402.839 341.669 402.306 342.019 401.72 342.256H401.71Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.78 329.476L529.01 231.226L523.93 225.916L408.72 323.456L413.78 329.476Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.81 197.506L532.54 215.686L531.34 223.206L539.56 223.026L561.27 203.956C564.67 199.956 562.73 192.416 554.77 197.496L554.81 197.506Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.92 203.966L553.1 211.176L546.92 203.966Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.92 203.966L553.1 211.176",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.15 213.086L542.47 220.466L536.15 213.086Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.15 213.086L542.47 220.466",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.88 287.156L615.79 284.156L580.94 261.926L579.03 264.926L613.88 287.156Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.25 276.626L615.83 269.446C618.314 265.538 619.772 261.067 620.07 256.446C620.45 250.366 620.07 245.526 614.8 242.146C609.73 238.916 605.51 240.196 600.44 242.886C595.849 245.36 591.975 248.977 589.19 253.386L585.04 259.896L611.25 276.626Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.54 280.136L612.45 277.136L583.94 258.926L582.03 261.926L610.54 280.136Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.88 264.096L593.88 262.496L592.03 261.316L591.03 262.916L592.88 264.096Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.54 272.626L587.06 270.236L584.06 268.316L582.54 270.706L585.54 272.626Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.25 289.506L561.08 290.026L561.68 287.916L559.85 287.396L559.25 289.506Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.25 293.506L565.08 294.026L565.68 291.916L563.85 291.396L563.25 293.506Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.25 284.506L567.08 285.026L567.68 282.916L565.85 282.396L565.25 284.506Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.25 288.506L571.08 289.026L571.68 286.916L569.85 286.396L569.25 288.506Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.25 279.506L572.08 280.026L572.68 277.916L570.85 277.396L570.25 279.506Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.25 283.506L576.08 284.026L576.68 281.916L574.85 281.396L574.25 283.506Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.25 274.506L579.08 275.026L579.68 272.916L577.85 272.396L577.25 274.506Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.25 278.506L583.08 279.026L583.68 276.916L581.85 276.396L581.25 278.506Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.54 225.626V223.726H593.37V225.626H597.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.54 225.626V223.726H613.37V225.626H617.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.54 225.626V223.726H603.37V225.626H607.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.88 272.096L606.88 270.496L605.03 269.316L604.03 270.916L605.88 272.096Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.91 261.746C614.261 261.746 619.41 256.597 619.41 250.246C619.41 243.895 614.261 238.746 607.91 238.746C601.559 238.746 596.41 243.895 596.41 250.246C596.41 256.597 601.559 261.746 607.91 261.746Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.91 257.246C611.776 257.246 614.91 254.112 614.91 250.246C614.91 246.38 611.776 243.246 607.91 243.246C604.044 243.246 600.91 246.38 600.91 250.246C600.91 254.112 604.044 257.246 607.91 257.246Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.91 253.746C609.843 253.746 611.41 252.179 611.41 250.246C611.41 248.313 609.843 246.746 607.91 246.746C605.977 246.746 604.41 248.313 604.41 250.246C604.41 252.179 605.977 253.746 607.91 253.746Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.91 251.746C608.739 251.746 609.41 251.075 609.41 250.246C609.41 249.418 608.739 248.746 607.91 248.746C607.082 248.746 606.41 249.418 606.41 250.246C606.41 251.075 607.082 251.746 607.91 251.746Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.54 194.126C608.473 194.126 610.04 192.559 610.04 190.626C610.04 188.693 608.473 187.126 606.54 187.126C604.607 187.126 603.04 188.693 603.04 190.626C603.04 192.559 604.607 194.126 606.54 194.126Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.54 282.126C670.473 282.126 672.04 280.559 672.04 278.626C672.04 276.693 670.473 275.126 668.54 275.126C666.607 275.126 665.04 276.693 665.04 278.626C665.04 280.559 666.607 282.126 668.54 282.126Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.2 297.726C390.33 298.477 388.239 298.454 386.386 297.662C384.533 296.871 383.071 295.376 382.32 293.506C381.57 291.636 381.593 289.545 382.384 287.692C383.175 285.839 384.67 284.377 386.54 283.626C387.463 283.253 388.451 283.064 389.447 283.073C390.443 283.081 391.427 283.285 392.344 283.673C393.261 284.062 394.093 284.627 394.791 285.337C395.49 286.047 396.042 286.888 396.415 287.811C396.789 288.734 396.977 289.722 396.969 290.718C396.961 291.714 396.757 292.698 396.368 293.615C395.979 294.532 395.414 295.364 394.704 296.062C393.994 296.761 393.153 297.313 392.23 297.686L392.2 297.726Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.67 294.196C396.061 294.419 395.39 294.398 394.797 294.135C394.204 293.873 393.736 293.39 393.492 292.79C393.248 292.189 393.247 291.517 393.489 290.915C393.732 290.314 394.198 289.83 394.79 289.566C395.405 289.317 396.095 289.322 396.706 289.581C397.317 289.84 397.801 290.331 398.05 290.946C398.299 291.561 398.294 292.25 398.035 292.862C397.776 293.473 397.285 293.957 396.67 294.206V294.196Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.54 290.626C345.425 295.694 343.331 300.515 339.706 304.058C336.082 307.602 331.214 309.586 326.145 309.586C321.076 309.586 316.208 307.602 312.584 304.058C308.959 300.515 306.865 295.694 306.75 290.626C306.865 285.558 308.959 280.737 312.584 277.194C316.208 273.65 321.076 271.667 326.145 271.667C331.214 271.667 336.082 273.65 339.706 277.194C343.331 280.737 345.425 285.558 345.54 290.626Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.92 290.626C341.922 293.746 340.999 296.796 339.267 299.39C337.535 301.985 335.073 304.008 332.192 305.203C329.31 306.398 326.139 306.712 323.079 306.104C320.02 305.497 317.209 303.996 315.002 301.791C312.796 299.586 311.293 296.776 310.684 293.716C310.074 290.657 310.386 287.486 311.579 284.604C312.773 281.721 314.794 279.258 317.388 277.525C319.981 275.791 323.03 274.866 326.15 274.866C330.331 274.866 334.34 276.526 337.297 279.482C340.255 282.437 341.917 286.445 341.92 290.626Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.16 290.626C329.16 291.219 328.984 291.799 328.655 292.293C328.325 292.786 327.856 293.171 327.308 293.398C326.76 293.625 326.157 293.684 325.575 293.568C324.993 293.453 324.458 293.167 324.039 292.747C323.619 292.328 323.334 291.793 323.218 291.211C323.102 290.629 323.161 290.026 323.389 289.478C323.616 288.93 324 288.461 324.493 288.132C324.987 287.802 325.567 287.626 326.16 287.626C326.956 287.626 327.719 287.942 328.281 288.505C328.844 289.067 329.16 289.83 329.16 290.626Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.04 266.126L341.04 259.126C341.04 259.126 357.04 269.126 359.04 284.126C361.04 299.126 352.63 293.626 352.63 293.626C352.63 293.626 349.04 290.126 350.04 282.126C350.59 277.736 348.22 275.546 346.04 273.246C344.04 271.126 343.29 273.126 342.04 273.126C341.26 273.126 339.88 271.916 338.84 270.916C338.606 270.69 338.451 270.396 338.397 270.075C338.343 269.755 338.393 269.426 338.54 269.136L339.04 268.136L336.04 266.126Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.67 291.196C355.061 291.419 354.39 291.398 353.797 291.135C353.204 290.873 352.736 290.39 352.492 289.79C352.248 289.189 352.247 288.517 352.489 287.915C352.732 287.314 353.198 286.83 353.79 286.566C354.405 286.317 355.095 286.322 355.706 286.581C356.317 286.84 356.801 287.331 357.05 287.946C357.299 288.561 357.294 289.25 357.035 289.862C356.776 290.473 356.285 290.957 355.67 291.206V291.196Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3058_89593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 790,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowProfile);
export default __webpack_public_path__ + "static/media/low-profile.9a12625ae423f7fd4076a0630149f666.svg";
export { ForwardRef as ReactComponent };